import { makeStyles } from "@material-ui/core/styles"

const globalUseStyles = makeStyles(() => ({
    sparcaButton: {
        width: "100%",
        minWidth: "200px",
        // maxWidth: "200px",
    },
    buttonLink: {
        textDecoration: "none",
    },
    buttonCenter: {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
    },
    paragraph: {
        marginBottom: "15px",
    },
    smallFont: {
        fontSize: "80%",
    },
    link:{
        textDecoration: 'none !important',
        color:'inherit'
    }
}))

export default globalUseStyles
